<div class="main">
    <div class="dx-field-title" translate>localAgentsExecutionTriggers.pageTitle</div>
    <div class="dx-field selector">
        <div class="dx-field-label">{{ this.currentEnvironmentName }}&nbsp;/</div>
        <div class="dx-field-value">
            <dx-select-box #agentPicker [dataSource]="localAgents" displayExpr="name" valueExpr="id" (selectedItemChange)="filterChanged($event)"
                           [noDataText]="'_pickers.nodata' | translate" [placeholder]="'_pickers.placeholder' | translate">
            </dx-select-box>
        </div>
    </div>
    <br />
    <dx-data-grid #executionTriggers 
                  [dataSource]="dataSource" 
                  keyExpr="id" 
                  [columnAutoWidth]="true" 
                  [wordWrapEnabled]="true"
                  height="calc(100vh - 210px)" 
                  hoverStateEnabled="true"
                  [errorRowEnabled]="false">
        <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxo-summary>
            <dxi-total-item column="day" [displayFormat]="'localAgentsExecutionTriggers.lblTriggersCount' | translate" summaryType="count"></dxi-total-item>
        </dxo-summary>
        <dxo-toolbar>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="displayNewPopup()"></dx-button>
                </div>
            </dxi-item>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadDataSource()"></dx-button>
                </div>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>

        <dxi-column dataField="day" [caption]="'localAgentsExecutionTriggers.lblDay' | translate" [calculateCellValue]="displayDay"></dxi-column>
        <dxi-column dataField="hour" [caption]="'localAgentsExecutionTriggers.lblHour' | translate"></dxi-column>
        <dxi-column [width]="100" cellTemplate='actionsCellTemplate'></dxi-column>
        <div *dxTemplate="let cell of 'actionsCellTemplate'">
            <dx-button class="delete" icon="trash" [hint]="'_commons.delete' | translate" (onClick)="deleteExecutionTrigger(cell.data.id)"></dx-button>
        </div>
    </dx-data-grid>
</div>

<!-- New popup -->
<dx-popup [title]="'localAgentsExecutionTriggers.popupTitle' | translate" [height]="290" [(visible)]="isPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view direction="vertical" *ngIf="isPopupVisible">
            <dx-validation-group #executionTriggerValidation>
                <div class="dx-field">
                    <div class="dx-field-label" translate>localAgentsExecutionTriggers.lblDay</div>
                    <div class="dx-field-value">
                        <app-day-picker [(selectedItem)]="selectedExecutionTrigger.day" [isRequired]="false"></app-day-picker>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>localAgentsExecutionTriggers.lblHour</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedExecutionTrigger.hour">
                            <dx-validator>
                                <dxi-validation-rule type="numeric" [message]="'_validators.numeric' | translate"></dxi-validation-rule>
                                <dxi-validation-rule type="range" [min]="0" [max]="23" [message]="'_validators.range1000' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
            </dx-validation-group>
            <div class="flex bottom-buttons">
                <dx-button class="add" [text]="'_commons.add' | translate" (onClick)="createExecutionTrigger()"
                    [visible]="isNew"></dx-button>
                <dx-button class="cancel" [text]="'_commons.cancel' | translate" (onClick)="this.isPopupVisible = false"></dx-button>
            </div>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
